import {
  UseFieldArrayRemove,
  UseFieldArrayUpdate,
  useFormContext,
} from "react-hook-form";
import { MenuProduct } from "../models/Menus";
import { MenuProductItem } from "./MenuProductItem";
import { useEffect } from "react";
import { MenuProductsFormValues } from "../MenuUpsert";
import { MenuOverwriteProductSelector } from "./MenuOverwriteProductSelector";
import {
  OverwriteMenuModalFormValues,
  OverwriteMenuModalProduct,
} from "./OverwriteMenuModal";

type Props = {
  remove: UseFieldArrayRemove;
  products: MenuProduct[] | OverwriteMenuModalProduct[];
  isOverwrite?: boolean;
  update?: UseFieldArrayUpdate<OverwriteMenuModalFormValues, "products">;
  originalMenuProducts: MenuProduct[] | undefined;
};

export const MenuCategoryGridItems = ({
  remove,
  products,
  isOverwrite,
  update,
  originalMenuProducts,
}: Props) => {
  const { setValue } = useFormContext<
    MenuProductsFormValues | OverwriteMenuModalFormValues
  >();

  // Updating sort keys to 1 -> no of products in category
  useEffect(() => {
    products.forEach((field, i) => {
      const sortKeyName = `products.${field.fieldIndex}.sortKey`;
      setValue(sortKeyName as any, i + 1);
    });
    // We do not want this effect to fire every time a change is made. We want it to fire when new products are added. Therefor products.length is used instead of just products in dependency array
    // eslint-disable-next-line
  }, [setValue, products.length]);

  return (
    <>
      {products.map((field, _) => {
        if (isOverwrite && update) {
          return (
            <MenuOverwriteProductSelector
              // Attribute used in onEnd function when updating sortKey. It is the index in the original products array
              data-id={field.fieldIndex}
              key={field.id}
              product={field as OverwriteMenuModalProduct}
              originalMenuProducts={originalMenuProducts}
              remove={remove}
              update={update}
            />
          );
        }
        return (
          <MenuProductItem
            // Attribute used in onEnd function when updating sortKey. It is the index in the original products array
            data-id={field.fieldIndex}
            key={field.id}
            remove={remove}
            product={field}
          />
        );
      })}
    </>
  );
};
